import { getDefaultEnseigneConfig, IEnseigneConfig } from '../alodb/AloDbEnseigne'

export class AloUser {
  public civilite: number
  public datAdd: Date
  public datLog: Date
  public disabled: boolean
  public email: string
  public ensId: number
  public ensKey: string
  public ensLibelle: string
  public ensConfigJson: string
  public groups: Array<number>
  public id: number
  public login: string
  public nom: string
  public passExpiresInDays: number
  public pass: string
  public prenom: string
  public roles: Array<string>
  public tel: string
  public config: IEnseigneConfig

  constructor({
    civilite = 1,
    datAdd = '',
    datLog = '',
    disabled = true,
    email = '',
    ensId = 0,
    ensKey = '',
    ensLibelle = '',
    ensConfigJson = '{}',
    groups = [],
    id = 0,
    login = '',
    nom = '',
    passExpiresInDays = 180,
    pass = '',
    prenom = '',
    roles = [],
    tel = '',
  } = {}) {
    this.civilite = civilite
    this.datAdd = new Date(datAdd)
    this.datLog = new Date(datLog)
    this.disabled = disabled
    this.email = email
    this.ensId = ensId
    this.ensKey = ensKey
    this.ensLibelle = ensLibelle
    this.ensConfigJson = ensConfigJson
    this.groups = groups
    this.id = id
    this.login = login
    this.nom = nom
    this.pass = pass
    this.prenom = prenom
    this.roles = roles
    this.tel = tel
    this.passExpiresInDays = passExpiresInDays
    this.config = {
      ...getDefaultEnseigneConfig(),
      ...JSON.parse(ensConfigJson ?? '{}'),
    } as IEnseigneConfig
  }
}
